import { Injectable } from '@angular/core';
import { AppConstant } from '@app/shared/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root'
})
export class UploadDesignService {
  // baseUrl = AppConstant.APP_BASE_URL;
  constructor(private http: HttpClient) { }
  uploadDesign(designDetail: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPLOADDESGIN_CREATE, designDetail);
  }

  getUploadedDesigns(searchString: any, skipNoOfRecord: number, takeNoRecord: number, storeId?: number) {
    let url = environment.baseUrl + AppConstant.UPLOADDESGIN_LIST + '?searchBy=' + searchString +
    '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord;
    if (storeId) {
      url += '&storeId=' + storeId;
    }
    return this.http.get(url);
  }

  editDesign(designId: any) {
    return this.http.get(environment.baseUrl + AppConstant.UPLOADDESGIN_EDIT + designId);
  }

  updateDesign(designDetail: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPLOADDESGIN_UPDATE, designDetail);
  }

  deleteDesign(uploadDesignId: any, modifiedBy: number) {
    return this.http.get(environment.baseUrl + AppConstant.UPLOADDESGIN_DELETE + '?UploadedDesignId=' +  uploadDesignId +
    '&ModifiedBy=' + modifiedBy);
  }
}
